import Hero from "../components/Hero";
import { useNavigate } from "react-router-dom";
import HeroImage from "../../assets/images/Mortgage1.jpg";
import mortageImage2 from "../../assets/images/Mortgage2.jpg";
import mortageImage3 from "../../assets/images/Mortgage3.jpg";
import mortageImage4 from "../../assets/images/teachers_image002.png";
import Accordion from "../designSystem/Accordion";
import { ReactComponent as Step1Icon } from "../../assets/icons/Mortgage1.svg";
import { ReactComponent as Step2Icon } from "../../assets/icons/Mortgage2.svg";
import { ReactComponent as Step3Icon } from "../../assets/icons/Mortgage3.svg";
import { ReactComponent as Step4Icon } from "../../assets/icons/Mortgage4.svg";
import { ReactComponent as Step5Icon } from "../../assets/icons/Mortgage5.svg";
import FeatureCards from "../designSystem/FeatureCards";
import FilledButton from "../designSystem/FilledButton";

const mortgageSteps = [
  {
    icon: Step1Icon,
    title: "Save for deposit and fees",
  },
  {
    icon: Step2Icon,
    title: "Check budget and borrowing power",
  },
  {
    icon: Step3Icon,
    title: "Get an Agreement in Principle",
  },
  {
    icon: Step4Icon,
    title: "Find a property and apply for a mortgage",
  },
  {
    icon: Step5Icon,
    title: "Complete legal work and move in",
  },
];

const MortgagePage = () => {
  const navigate = useNavigate();
  return (
    <div className="home-page">
      <Hero
        title="Mortgages"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">What is a Mortgage?</h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                A mortgage is a loan used to buy property or land, typically
                repaid over up to 40 years. It is secured against your home,
                meaning your property could be repossessed if you fail to keep
                up repayments. Interest is charged on the amount borrowed—higher
                rates mean higher costs.
              </div>
              <div className="content-semibold grey align-left">
                Most lenders require a deposit of at least 5%, although a larger
                deposit can unlock better deals.
              </div>
            </div>
            <img
              src={mortageImage2}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Types of Mortgage Repayment</h2>
            <div className="divider burgandy" />
            <Accordion title="Repayment Mortgage">
              Pay both interest and part of the loan each month, gradually
              reducing the balance.
            </Accordion>
            <Accordion title="Interest-Only Mortgage">
              Pay only the interest monthly. The full loan must be repaid at the
              end of the term (requires a repayment plan).
            </Accordion>
            <Accordion title="Combination Mortgage">
              Part repayment and part interest-only.
            </Accordion>
            <Accordion title="Mortgage Rate Types">
              <ul>
                <li>
                  Fixed Rate – Your interest rate stays the same for a set
                  period (e.g. 2–5 years).
                </li>
                <li>
                  Variable / Tracker Rate – Follows the Bank of England base
                  rate, so payments can rise or fall.
                </li>
              </ul>
            </Accordion>
            <Accordion title="Common Mortgage Options">
              <ul>
                <li>
                  First-Time Buyer Mortgages – Designed for those buying their
                  first home.
                </li>
                <li>
                  Buy-to-Let Mortgages – For renting out property (not FCA
                  regulated).
                </li>
                <li>
                  Remortgaging – Switching to a new deal, often to save money or
                  borrow more.
                </li>
                <li>
                  Offset Mortgages – Link savings to reduce interest charged.
                </li>
                <li>
                  Self-Build Mortgages – Funds released in stages for building
                  your own home.
                </li>
                <li>
                  Bridging Loans - Short-term funding to help you secure a
                  property quickly while you arrange longer-term finance or
                  complete a sale.
                </li>
              </ul>
            </Accordion>
            <Accordion title="Buy-to-Let Overview">
              <ul>
                <li>Typically interest-only</li>
                <li>Larger deposits (usually 20–40%)</li>
                <li>Higher fees and interest rates</li>
                <li>Rental income is taxable</li>
                <li>Often requires good credit and stable income</li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="column">
            <h2 className="burgandy">First-Time Buyer Steps</h2>
            <div className="divider burgandy" />
            <FeatureCards features={mortgageSteps} />
          </div>
        </div>
      </section>
      <section className="burgandy-container">
        <div className="burgandy-container-content">
          <div className="row">
            <img
              src={mortageImage3}
              alt="WPP Financial Services Building"
              className="image-container"
            />
            <div className="column">
              <h2 className="align-left">Remortgaging</h2>
              <div className="divider align-left" />
              <div className="row">
                <div className="content-column">
                  <div className="content align-left">
                    Remortgaging means switching your mortgage to a new deal
                    without moving home. This can help reduce monthly payments
                    or release equity, but may involve fees or early repayment
                    charges.
                  </div>
                  <div className="content-semibold align-left">
                    Key considerations: Your home may be repossessed if you do
                    not keep up repayments, Larger deposits usually mean better
                    rates, Mortgage terms and types should match your financial
                    situation, Always consider fees, interest rates, and
                    long-term affordability.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">
                Expert mortgage advice, tailored to the teaching profession.
              </h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Whether you're buying your first home, moving house or
                remortgaging, WPP Financial Services provides straightforward
                mortgage advice tailored to teachers and their individual
                circumstances.
              </div>
              <div className="content-semibold grey align-left">
                We understand that teaching is a demanding profession, with busy
                schedules and limited free time. That's why we work around your
                availability and aim to make the mortgage process as simple,
                clear and hassle-free as possible.
              </div>
              <div className="help_text grey align-left">
                Your home may be repossessed if you do not keep up repayments,
                Larger deposits usually mean better rates, Mortgage terms and
                types should match your financial situation, Always consider
                fees, interest rates, and long-term affordability.
              </div>
              <FilledButton
                text={"Learn More"}
                onClick={() => navigate("/mortgage-advice-for-teachers")}
              />
            </div>
            <img
              src={mortageImage4}
              alt="Expert mortgage advice for teachers"
              className="image-container"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default MortgagePage;
